export default {
  async mounted(el, binding) {
    try {
      const response = await fetch(binding.value);
      if (!response.ok) throw new Error('Failed to load SVG');

      const svgText = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(svgText, 'image/svg+xml');
      const svgElement = doc.querySelector('svg');

      if (svgElement) {
        el.replaceWith(svgElement); // Replace placeholder element with the actual SVG
      }
    } catch (error) {
      console.error('Error loading SVG:', error);
    }
  },
};
